// extracted by mini-css-extract-plugin
export default {"input-reg":"InputReg_input-reg__eEOH-"};